import { Filter } from "@p0security/shared/types/workflow/types";
import { Typography } from "antd";
import { MiddleTruncatedText } from "components/common/MiddleTruncatedText";
import pluralize from "pluralize";
import { useMemo } from "react";

type Props = {
  filter: Filter;
  filterType: string;
};

export const ResourceFilterPreview: React.FC<Props> = ({
  filter,
  filterType,
}) => {
  // @TODO: Fetch/resolve # of hits for filter, eg. "3 roles matching tag [xyz]"
  const filterTypeDisplay = useMemo(
    () =>
      filterType ? (
        <Typography.Text underline>
          {pluralize(filterType as string)}
        </Typography.Text>
      ) : null,
    [filterType]
  );

  const filterKeyDisplay = useMemo(
    () =>
      filter && filter.effect !== "removeAll" && "key" in filter ? (
        <Typography.Text underline>{filter.key}</Typography.Text>
      ) : null,
    [filter]
  );

  const filterContentDisplay = useMemo(() => {
    if (filter.effect === "removeAll") return null;

    const value = "value" in filter ? String(filter.value) : filter.pattern;

    return (
      <MiddleTruncatedText
        code
        suffixLength={16}
        text={value}
        className="inline-block max-w-md align-top"
      />
    );
  }, [filter]);

  return filter?.effect === "removeAll" ? (
    <Typography.Text>Exclude all {filterTypeDisplay}</Typography.Text>
  ) : filter?.effect === "remove" ? (
    <Typography.Text>
      Exclude {filterTypeDisplay} with {filterKeyDisplay} {filterContentDisplay}
    </Typography.Text>
  ) : (
    <Typography.Text>
      Include only {filterTypeDisplay} matching {filterKeyDisplay}{" "}
      {filterContentDisplay}
    </Typography.Text>
  );
};
